import React, { useState, useEffect } from 'react';
import { doc, getDoc, getDocs, collection } from 'firebase/firestore';
import { db } from './firebase';
import { C } from './constants';
import { ANTHROPIC_API_KEY, copierTexteRobuste } from './App';

export function AssistanteIATab({uid, userName, goToTab=()=>{}}){
  const[ouvert,setOuvert]=useState(false);
  const[messages,setMessages]=useState([]);
  const[input,setInput]=useState("");
  const[loading,setLoading]=useState(false);
  const[ordonnanceEnvoyee,setOrdonnanceEnvoyee]=useState({});
  const[reponseCopiee,setReponseCopiee]=useState(null);
  const[afficherVIPAssistante,setAfficherVIPAssistante]=useState(false);

  useEffect(()=>{
    if(!uid)return;
    (async()=>{
      try{
        const snapU=await getDoc(doc(db,"users",uid));
        if(snapU.exists())setAfficherVIPAssistante(!!snapU.data()["db-afficher-prix-vip"]);
      }catch{}
    })();
  },[uid]);

  const ouvrirChat=()=>{
    setOuvert(true);
    if(messages.length===0){
      setMessages([{role:"assistant",text:`Coucou ${userName?.split(" ")[0]||""} ! 👋 Je suis ton assistante Blazing Dynasty. Je peux t'aider à conseiller tes clientes sur les produits Mihi (avec ordonnance et prix), répondre à tes questions business, ou juste t'écouter si t'as besoin d'en parler. Ou pour t'aider à utiliser l'appli. De quoi as-tu besoin ?`}]);
    }
  };

  const envoyer=async()=>{
    const texte=input.trim();
    if(!texte||loading)return;
    const newMsgs=[...messages,{role:"user",text:texte}];
    setMessages(newMsgs);
    setInput("");
    setLoading(true);

    try{
      // Charger le catalogue produits
      let catalogueText="";
      let allProduits=[];
      try{
        const catSnap=await getDoc(doc(db,"admin","catalogue_mihi"));
        if(catSnap.exists()){
          const cat=catSnap.data();
          // TOUT le catalogue, toutes catégories (visage, corps, cheveux, maquillage, parfums, santé, hommes, enfants, HOME/entretien, sets, nutrition...), sans limite
          const LABELS={face:"VISAGE",corps:"CORPS",hair:"CHEVEUX",makeup:"MAQUILLAGE",parfums:"PARFUMS",health:"SANTÉ",hommes:"HOMMES",enfants:"ENFANTS",home:"HOME (produits d'entretien et soins de la maison)",sets:"SETS / COFFRETS",nutrition:"NUTRITION / COMPLÉMENTS"};
          const blocs=[];
          Object.entries(cat).forEach(([cle,liste])=>{
            if(!Array.isArray(liste)||liste.length===0)return;
            const label=LABELS[cle]||String(cle).toUpperCase();
            liste.forEach(p=>allProduits.push({...p,_cat:label}));
            blocs.push(`### ${label} (${liste.length} produits)\n`+liste.map(p=>`- ${p.nom} | ${p.prix}€${p.prixVIP?` (VIP ${p.prixVIP}€)`:""}${p.rupture?" | ⛔ EN RUPTURE : ne jamais le proposer":""}`).join("\n"));
          });
          catalogueText=blocs.join("\n\n");
        }
      }catch{}

      // Charger les contenus de formation (textes admin)
      let formationText="";
      try{
        const formSnap=await getDoc(doc(db,"admin","contenus"));
        if(formSnap.exists()){
          const items=(formSnap.data().items||[]).filter(i=>i.actif!==false&&i.description);
          formationText=items.slice(0,30).map(i=>`[${i.destination}] ${i.titre}: ${i.description}`).join("\n");
        }
      }catch{}

      // Charger formation produits (textes détaillés par catégorie)
      let produitsFormationText="";
      const produitsFormation=[]; // {titre, refCatalogue}
      try{
        let produitsF={};
        try{
          // Nouvelle structure : un document par catégorie (compléments, perte de poids, entretien, problématiques...)
          const snapC=await getDocs(collection(db,"admin","formation_produits_categories","items"));
          if(!snapC.empty)snapC.forEach(d=>{produitsF[d.id]=d.data().items||[];});
        }catch{}
        if(Object.keys(produitsF).length===0){
          const fpSnap=await getDoc(doc(db,"admin","formation_produits"));
          if(fpSnap.exists())produitsF=fpSnap.data().produits||{};
        }
        const CATS_F={parfum:"PARFUM",makeup:"MAQUILLAGE",complement:"COMPLÉMENTS ALIMENTAIRES",nutrition:"NUTRITION",poids:"PERTE DE POIDS",skincare:"SKINCARE",cheveux:"SOINS CHEVEUX",corpsoin:"SOINS CORPS",entretien:"PRODUITS D'ENTRETIEN",problematiques:"PAR PROBLÉMATIQUE"};
        const normF=(t)=>String(t||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]+/g," ").trim();
        const lignes=[];
        let total=0;
        Object.entries(produitsF).forEach(([cat,liste])=>{
          if(cat==="formations_video")return;
          (liste||[]).forEach(p=>{
            if(!p||!p.titre)return;
            produitsFormation.push({titre:p.titre,refCatalogue:p.refCatalogue||""});
            let lien="";
            if(p.refCatalogue){
              const cp=allProduits.find(x=>String(x.ref)===String(p.refCatalogue)||normF(x.nom)===normF(p.refCatalogue));
              if(cp)lien=` (dans le catalogue : ${cp.nom}, ${cp.prix}€${cp.rupture?", EN RUPTURE":""})`;
            }
            const desc=String(p.description||"").replace(/\s+/g," ").trim().slice(0,600);
            const l=`- [${CATS_F[cat]||cat}${p.theme?" / "+p.theme:""}] ${p.titre}${lien}${desc?" : "+desc:""}`;
            if(total+l.length>70000)return;
            total+=l.length;
            lignes.push(l);
          });
        });
        produitsFormationText=lignes.join("\n");
      }catch{}

      const historique=newMsgs.slice(-8).map(m=>`${m.role==="user"?"Distributrice":"Assistante"}: ${m.text}`).join("\n");

      const prompt=`Tu es l'assistante IA de l'équipe Blazing Dynasty (Mihi France), une équipe de vente directe en MLM. Tu parles à une distributrice de l'équipe, jamais à une cliente finale.

CONTEXTE FORMATIONS DE L'ÉQUIPE :
${formationText||"Aucune formation chargée pour l'instant."}

FORMATIONS PRODUITS DE L'ÉQUIPE (ce que sont les produits, à quoi ils servent, par catégorie et par problématique : compléments, perte de poids, nutrition, entretien, skincare...). C'est une source officielle, au même titre que le catalogue :
${produitsFormationText||"Aucun détail produit chargé."}

AIDE UTILISATION DE L'APPLICATION (utilise ceci si la distributrice demande comment faire quelque chose DANS l'appli Blazing Dynasty, pas pour conseiller une cliente) :
- dashboard (Aujourd'hui) : ecran d'accueil, jauge de progression vers les objectifs, badges, actions du jour a cocher
- objectifs : suivre son chiffre d'affaires periode par periode, definir son objectif CA et palier
- linkbio : creer sa page LinkBio publique (photo, liens boutique/recrutement, Mon Parcours, reseaux sociaux)
- dreamboard : tableau de visualisation des reves, ajouter des photos/reves avec categorie
- diagnostics : faire un diagnostic produit personnalise pour une cliente (skincare, parfum, silhouette...)
- calendrier : voir les evenements d'equipe (Zooms, formations, deadlines)
- scripts : bibliotheque de messages types prets a copier-coller
- banqueimages : visuels a partager pour les reseaux sociaux
- sprint : defis de vente sur une periode courte
- suivi : suivi onboarding des nouvelles recrues
- espacechef : (reserve cheffes d'equipe) statistiques equipe, gestion des acces, challenges, suivi assiduite
- formation : centre de formation (demarrage, vente, recrutement, contenu, developpement perso, outils)
- Pour changer son mot de passe : bouton 🔐 en haut a droite de l'ecran d'accueil
- Pour ajouter/suivre des clientes ou prospects : onglets Clients et Prospects (menu principal)

CATALOGUE COMPLET MIHI FRANCE (toutes les catégories, avec les prix réels et les ruptures). Il fait foi pour les PRIX et la DISPONIBILITÉ.
${catalogueText||"Catalogue non chargé."}

RÈGLES ABSOLUES SUR LES PRODUITS :
- Pour trouver un produit, cherche TOUJOURS dans les deux sources : le catalogue ci-dessus ET les formations produits (par nom, par catégorie, par problématique : ex. sucre, cholestérol, minceur, digestion, énergie, entretien...). Un produit présent dans l'une des deux existe.
- Ne cite et ne recommande QUE des produits présents dans le catalogue ou dans les formations produits, avec leur nom exact. N'invente JAMAIS un produit, un nom, un prix ni une gamme, et ne te base pas sur tes connaissances générales sur Mihi.
- Le prix vient du catalogue. Si un produit existe dans les formations mais pas dans le catalogue, tu peux le proposer en indiquant que son prix est à vérifier.
- Ne dis JAMAIS qu'une catégorie ou un produit n'existe plus ou n'existe pas sans avoir cherché dans le catalogue ET dans les formations produits. Il y a une catégorie HOME / produits d'entretien : regarde-la avant de répondre. Un produit marqué EN RUPTURE existe mais n'est pas disponible pour le moment : dis-le.
- Pour dire à quoi sert un produit, appuie-toi sur sa description dans les formations produits et dis "d'après la formation". Tu peux relayer ce que la formation dit, sans rien ajouter de ton côté : pas de promesse de santé, pas de guérison, pas de résultat garanti, et rappelle qu'un complément ne remplace ni un traitement ni l'avis d'un médecin quand il s'agit de santé (sucre, cholestérol...).
- Si, après avoir cherché dans les deux sources, rien ne correspond clairement, dis-le honnêtement ("je ne trouve pas de produit qui correspond exactement dans le catalogue ni dans les formations") plutôt que d'en inventer un.
- N'affirme jamais qu'un produit "garantit" un résultat, qu'il est "efficace" à coup sûr, ni qu'on peut associer ou prendre plusieurs produits ensemble "sans souci", sauf si la formation le dit mot pour mot. Pas de "réachat garanti" ni de promesse de revenus : reste factuelle et mesurée.
- N'utilise aucun markdown : pas d'astérisques, pas de titres avec #. Écris en texte simple, avec des tirets ou des emojis pour les listes.
- Si tu n'es pas sûre d'une information, dis "à vérifier" plutôt que de deviner.

HISTORIQUE DE LA CONVERSATION :
${historique}

INSTRUCTIONS :
- Si la distributrice te pose une question PRODUIT (pour conseiller une cliente) : génère une réponse en JSON avec 3 packs et prix exacts du catalogue (format ci-dessous)
- Si la question est BUSINESS (stratégie, recrutement, vente, organisation) : réponds en JSON avec type "texte", contenu utile et concret basé sur les formations ci-dessus
- Si la question est MOOD/personnelle (fatigue, doute, motivation) : réponds en JSON avec type "texte", chaleureux et empathique, sans psychanalyser
- Si la question porte sur COMMENT UTILISER L'APPLICATION (naviguer, trouver une fonctionnalite, comprendre un outil) : reponds en JSON avec type "app", en te basant sur AIDE UTILISATION DE L'APPLICATION ci-dessus. Inclus le champ "onglet" avec l'identifiant exact de l'outil concerne (ex: "linkbio", "dreamboard") si un seul outil est clairement concerne, sinon omets ce champ
- Réponds TOUJOURS en français, ton "cash mais élégant" (direct, bienveillant, jamais mièvre)
- Réponds UNIQUEMENT avec le JSON, sans markdown ni commentaire

FORMAT JSON SI PRODUITS (type="produits") :
{"type":"produits","analyse":"2-3 phrases analysant le besoin","packs":[{"nom":"Pack Essentiel","emoji":"💚","produits":[{"nom":"Nom exact du catalogue","prix":XX,"role":"pourquoi ce produit"}],"total":XX},{"nom":"Pack Recommandé","emoji":"⭐","produits":[...],"total":XX},{"nom":"Pack Premium","emoji":"👑","produits":[...],"total":XX}],"conseil":"conseil final"}

FORMAT JSON SI TEXTE (type="texte", business ou mood) :
{"type":"texte","reponse":"ta réponse complète et utile"};

FORMAT JSON SI AIDE APPLICATION (type="app") :
{"type":"app","reponse":"explication claire et concrete des etapes a suivre","onglet":"identifiant_onglet_ou_omis"}`;

      const res=await fetch("https://api.anthropic.com/v1/messages",{
        method:"POST",
        headers:{"Content-Type":"application/json","x-api-key":ANTHROPIC_API_KEY,"anthropic-version":"2023-06-01","anthropic-dangerous-direct-browser-access":"true"},
        body:JSON.stringify({model:"claude-sonnet-4-6",max_tokens:2500,temperature:0.2,messages:[{role:"user",content:prompt}]})
      });
      const data=await res.json();
      const raw=data.content?.map(x=>x.text||"").join("").trim()||"{}";
      const match=raw.match(/\{[\s\S]*\}/);
      let parsed=match?JSON.parse(match[0]):{type:"texte",reponse:"Désolée, je n'ai pas pu traiter ta demande. Réessaie."};

      // Nettoyage : pas d'astérisques ni de titres markdown affichés tels quels
      const nettoie=(t)=>typeof t==="string"?t.replace(/\*\*(.+?)\*\*/g,"$1").replace(/^#{1,6}\s*/gm,"").replace(/__(.+?)__/g,"$1"):t;
      ["reponse","analyse","conseil"].forEach(k=>{if(parsed&&parsed[k])parsed[k]=nettoie(parsed[k]);});

      // Contrôle de chaque produit proposé : il doit exister dans le vrai catalogue et ne pas être en rupture.
      // Les prix (et le total) viennent du catalogue, jamais de l'IA.
      if(parsed.type==="produits"&&Array.isArray(parsed.packs)){
        const norm=(t)=>String(t||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]+/g," ").trim();
        const parNom=new Map();
        allProduits.forEach(cp=>{const k=norm(cp.nom);if(k&&!parNom.has(k))parNom.set(k,cp);});
        const retrouver=(nom)=>{
          const k=norm(nom);
          if(!k)return null;
          if(parNom.has(k))return parNom.get(k);
          const proches=[...parNom.entries()].filter(([kk])=>kk.includes(k)||k.includes(kk));
          if(proches.length===1)return proches[0][1];
          // Pas dans le catalogue : existe-t-il dans les formations produits ?
          const pf=produitsFormation.filter(f=>{const kf=norm(f.titre);return kf&&(kf===k||(k.length>=4&&(kf.includes(k)||k.includes(kf))));});
          if(pf.length>=1){
            const liee=pf.map(f=>f.refCatalogue?allProduits.find(x=>String(x.ref)===String(f.refCatalogue)||norm(x.nom)===norm(f.refCatalogue)):null).find(Boolean);
            if(liee)return liee;
            return {nom:pf[0].titre,prix:null,horsCatalogue:true};
          }
          return null;
        };
        let retires=0,enRupture=0,sansPrix=0;
        parsed.packs.forEach(pack=>{
          const garde=[];
          (Array.isArray(pack.produits)?pack.produits:[]).forEach(pr=>{
            const trouve=retrouver(pr.nom);
            if(!trouve){retires++;return;}
            if(trouve.rupture){enRupture++;return;}
            if(trouve.horsCatalogue)sansPrix++;
            garde.push({...pr,nom:trouve.nom,prix:trouve.horsCatalogue?null:trouve.prix,prixVIP:trouve.prixVIP||undefined});
          });
          pack.produits=garde;
          pack.total=Math.round(garde.reduce((s,x)=>s+(Number(x.prix)||0),0)*100)/100;
          pack.prixIncomplets=garde.some(x=>x.prix==null);
          const tousOntVIP=garde.length>0&&garde.every(x=>x.prixVIP);
          if(tousOntVIP){pack.totalVIP=Math.round(garde.reduce((s,x)=>s+x.prixVIP,0)*100)/100;}else{delete pack.totalVIP;}
        });
        parsed.packs=parsed.packs.filter(pk=>pk.produits.length>0);
        if(parsed.packs.length===0){
          parsed={type:"texte",reponse:(parsed.analyse?parsed.analyse+"\n\n":"")+"Je ne trouve pas de produit qui correspond exactement à ce besoin, ni dans le catalogue ni dans les formations produits. Dis-moi un peu plus ce que ta cliente cherche (soin, usage, budget) et je regarde ce qu'on a de plus proche."};
        }else if(retires>0||enRupture>0||sansPrix>0){
          const notes=[];
          if(sansPrix>0)notes.push(`${sansPrix} produit${sansPrix>1?"s":""} vien${sansPrix>1?"nent":"t"} des formations mais pas du catalogue : prix à vérifier`);
          if(retires>0)notes.push(`${retires} produit${retires>1?"s":""} proposé${retires>1?"s":""} par l'IA ne figure${retires>1?"nt":""} ni dans le catalogue ni dans les formations et ${retires>1?"ont":"a"} été retiré${retires>1?"s":""}`);
          if(enRupture>0)notes.push(`${enRupture} produit${enRupture>1?"s":""} en rupture ${enRupture>1?"ont":"a"} été retiré${enRupture>1?"s":""}`);
          parsed.avertissement="ℹ️ "+notes.join(" · ")+". Vérifie toujours avant d'envoyer à ta cliente.";
        }
      }

      setMessages(m=>[...m,{role:"assistant",...parsed}]);
    }catch(e){
      setMessages(m=>[...m,{role:"assistant",type:"texte",reponse:"Oups, petit souci technique 😅 Réessaie dans quelques secondes."}]);
    }
    setLoading(false);
  };

  // Copie le texte d'une réponse de l'assistante pour le coller ailleurs (WhatsApp, notes...)
  const copierReponse=async(idx,texte)=>{
    const ok=await copierTexteRobuste(String(texte||""));
    setReponseCopiee(ok?idx:"erreur-"+idx);
    setTimeout(()=>setReponseCopiee(null),2200);
  };
  const BoutonCopierReponse=({idx,texte})=>(
    <button onClick={()=>copierReponse(idx,texte)}
      style={{display:"block",marginTop:".45rem",background:reponseCopiee===idx?C.vert:"transparent",color:reponseCopiee===idx?"white":C.brun,border:`1px solid ${reponseCopiee===idx?C.vert:C.pale}`,borderRadius:8,padding:".28rem .65rem",fontSize:".66rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
      {reponseCopiee===idx?"✅ Copié !":reponseCopiee==="erreur-"+idx?"Copie impossible":"📋 Copier"}
    </button>
  );

  const envoyerOrdonnance=async(msgIdx,packs)=>{
    const texte=packs.map(p=>`${p.emoji} ${p.nom} (${p.total}€${p.prixIncomplets?" + produit(s) à prix à vérifier":""})\n${p.produits.map(pr=>`• ${pr.nom} — ${pr.prix==null?"prix à vérifier":pr.prix+"€"}`).join("\n")}`).join("\n\n");
    await copierTexteRobuste(texte);
    setOrdonnanceEnvoyee(p=>({...p,[msgIdx]:true}));
    setTimeout(()=>setOrdonnanceEnvoyee(p=>({...p,[msgIdx]:false})),2500);
  };

  if(!ouvert){
    return(
      <div onClick={ouvrirChat}
        style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:14,padding:".9rem 1rem",marginBottom:"1rem",cursor:"pointer",display:"flex",alignItems:"center",gap:".75rem",boxShadow:"0 3px 12px rgba(61,31,14,.15)"}}>
        <div style={{width:46,height:46,borderRadius:"50%",background:`linear-gradient(135deg,${C.rose},${C.lilas})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.4rem",flexShrink:0}}>
          🤖
        </div>
        <div style={{flex:1}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:".92rem",fontWeight:600,color:"white"}}>Comment puis-je t'aider et répondre ?</div>
          <div style={{fontSize:".68rem",color:C.pale,marginTop:".1rem"}}>Produits · Business · Petit coup de mou — je suis là</div>
        </div>
        <div style={{color:C.or,fontSize:"1.1rem"}}>→</div>
      </div>
    );
  }

  return(
    <div style={{background:C.blanc,border:`1.5px solid ${C.rose}40`,borderRadius:14,marginBottom:"1rem",overflow:"hidden"}}>
      {/* Header */}
      <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,padding:".75rem 1rem",display:"flex",alignItems:"center",gap:".6rem"}}>
        <div style={{width:36,height:36,borderRadius:"50%",background:`linear-gradient(135deg,${C.rose},${C.lilas})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",flexShrink:0}}>🤖</div>
        <div style={{flex:1}}>
          <div style={{fontSize:".82rem",fontWeight:700,color:"white"}}>Assistante Blazing Dynasty</div>
          <div style={{fontSize:".6rem",color:C.pale}}>Produits · Business · Mood</div>
        </div>
        <button onClick={()=>setOuvert(false)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:7,padding:".25rem .5rem",color:"white",cursor:"pointer",fontSize:".7rem",fontFamily:"inherit"}}>✕</button>
      </div>

      {/* Messages */}
      <div style={{maxHeight:420,overflowY:"auto",padding:".85rem"}}>
        {messages.map((m,i)=>{
          if(m.role==="user"){
            return(
              <div key={i} style={{display:"flex",justifyContent:"flex-end",marginBottom:".6rem"}}>
                <div style={{background:C.rose,color:"white",borderRadius:"12px 12px 2px 12px",padding:".5rem .75rem",fontSize:".78rem",maxWidth:"80%",lineHeight:1.5}}>{m.text}</div>
              </div>
            );
          }
          // Assistant
          if(m.text){
            // Message d'accueil simple
            return(
              <div key={i} style={{display:"flex",marginBottom:".6rem"}}>
                <div style={{background:C.creme,color:C.texte,borderRadius:"12px 12px 12px 2px",padding:".5rem .75rem",fontSize:".78rem",maxWidth:"85%",lineHeight:1.6}}>{m.text}</div>
              </div>
            );
          }
          if(m.type==="produits"){
            return(
              <div key={i} style={{marginBottom:".75rem"}}>
                <div style={{background:C.creme,borderRadius:"12px 12px 12px 2px",padding:".65rem .8rem",fontSize:".78rem",color:C.texte,lineHeight:1.6,marginBottom:".5rem"}}>
                  {m.analyse}
                </div>
                {(m.packs||[]).map((pack,pi)=>(
                  <div key={pi} style={{background:C.blanc,border:`1.5px solid ${C.pale}`,borderRadius:11,padding:".6rem .75rem",marginBottom:".4rem"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".35rem"}}>
                      <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>{pack.emoji} {pack.nom}</div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontFamily:"Georgia,serif",fontSize:".85rem",fontWeight:700,color:C.rose}}>{pack.total}€{pack.prixIncomplets?" +":""}</div>
                        {afficherVIPAssistante&&pack.totalVIP&&(
                          <div style={{fontSize:".62rem",fontWeight:700,color:"#8B6FB3"}}>💎 VIP {pack.totalVIP}€</div>
                        )}
                      </div>
                    </div>
                    {(pack.produits||[]).map((pr,pri)=>(
                      <div key={pri} style={{display:"flex",justifyContent:"space-between",fontSize:".68rem",color:C.gris,padding:".15rem 0"}}>
                        <span>• {pr.nom}</span>
                        <span style={{textAlign:"right",flexShrink:0,marginLeft:".5rem"}}>
                          <span style={{fontWeight:600,color:C.brun}}>{pr.prix==null?"prix à vérifier":pr.prix+"€"}</span>
                          {afficherVIPAssistante&&pr.prixVIP&&(
                            <span style={{display:"block",fontSize:".6rem",fontWeight:700,color:"#8B6FB3"}}>💎 {pr.prixVIP}€</span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                ))}
                {m.avertissement&&<div style={{fontSize:".66rem",color:"#B26A00",padding:".4rem .6rem",background:"#FFF3E0",borderRadius:8,marginBottom:".5rem",lineHeight:1.45}}>{m.avertissement}</div>}
                {m.conseil&&<div style={{fontSize:".72rem",color:C.brun,fontStyle:"italic",padding:".5rem .65rem",background:"#FFF8E1",borderRadius:8,marginBottom:".5rem"}}>💛 {m.conseil}</div>}
                <button onClick={()=>envoyerOrdonnance(i,m.packs)}
                  style={{width:"100%",background:ordonnanceEnvoyee[i]?C.vert:C.brun,color:"white",border:"none",borderRadius:9,padding:".5rem",fontSize:".74rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                  {ordonnanceEnvoyee[i]?"✓ Copiée — colle-la à ta cliente !":"📋 Copier l'ordonnance pour l'envoyer"}
                </button>
              </div>
            );
          }
          if(m.type==="texte"){
            return(
              <div key={i} style={{display:"flex",marginBottom:".6rem"}}>
                <div style={{background:C.creme,color:C.texte,borderRadius:"12px 12px 12px 2px",padding:".5rem .75rem",fontSize:".78rem",maxWidth:"85%",lineHeight:1.6,whiteSpace:"pre-wrap"}}>{m.reponse}<BoutonCopierReponse idx={i} texte={m.reponse}/></div>
              </div>
            );
          }
          if(m.type==="app"){
            return(
              <div key={i} style={{display:"flex",marginBottom:".6rem"}}>
                <div style={{background:C.creme,color:C.texte,borderRadius:"12px 12px 12px 2px",padding:".5rem .75rem",fontSize:".78rem",maxWidth:"85%",lineHeight:1.6}}>
                  <div style={{whiteSpace:"pre-wrap",marginBottom:m.onglet?".5rem":0}}>{m.reponse}</div>
                  <BoutonCopierReponse idx={i} texte={m.reponse}/>
                  {m.onglet&&(
                    <button onClick={()=>goToTab(m.onglet)}
                      style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".7rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                      Aller à cet outil →
                    </button>
                  )}
                </div>
              </div>
            );
          }
          if(m.type==="app"){
            return(
              <div key={i} style={{display:"flex",marginBottom:".6rem"}}>
                <div style={{background:C.creme,color:C.texte,borderRadius:"12px 12px 12px 2px",padding:".5rem .75rem",fontSize:".78rem",maxWidth:"85%",lineHeight:1.6}}>
                  <div style={{whiteSpace:"pre-wrap",marginBottom:m.onglet?".5rem":0}}>{m.reponse}</div>
                  <BoutonCopierReponse idx={i} texte={m.reponse}/>
                  {m.onglet&&(
                    <button onClick={()=>goToTab(m.onglet)}
                      style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".4rem .7rem",fontSize:".7rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
                      Aller à cet outil →
                    </button>
                  )}
                </div>
              </div>
            );
          }
          return null;
        })}
        {loading&&(
          <div style={{display:"flex",marginBottom:".6rem"}}>
            <div style={{background:C.creme,borderRadius:"12px 12px 12px 2px",padding:".5rem .75rem",fontSize:".78rem",color:C.gris}}>✨ Je réfléchis...</div>
          </div>
        )}
      </div>

      {/* Input */}
      <div style={{display:"flex",gap:".4rem",padding:".65rem .85rem",borderTop:`1px solid ${C.pale}`}}>
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&envoyer()}
          placeholder="Pose ta question..."
          style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:9,padding:".5rem .7rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
        <button onClick={envoyer} disabled={loading||!input.trim()}
          style={{background:loading||!input.trim()?C.pale:C.brun,color:"white",border:"none",borderRadius:9,padding:".5rem .85rem",fontSize:".82rem",fontWeight:600,fontFamily:"inherit",cursor:loading?"default":"pointer"}}>
          →
        </button>
      </div>
    </div>
  );
}



